module.exports = __webpack_public_path__ + "img/tab2-active.8a95afb3.png";